<template>
  <v-container fluid class="main-container">
    
    <v-row>
      <v-col>
        <v-tabs v-model="tab" centered icons-and-text fixed-tabs>
          <v-tabs-slider></v-tabs-slider>

          <!--  CreateInvoice TAB  -->
          <v-tab href="#tab-1">
            {{ $t('createNewInvoice') }}
            <v-icon>description</v-icon>
          </v-tab>

          <!--  UploadXml TAB  -->
          <v-tab href="#tab-2">
            XML
            <v-icon>code</v-icon>
          </v-tab>

          <!--  UploadExcel TAB  -->
          <v-tab href="#tab-3" disabled>
            Excel
            <v-icon>table_chart</v-icon>
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <!--  CreateInvoice TAB Content -->
          <v-tab-item value="tab-1">
            <v-card flat>
            <v-card-title>
              &nbsp;
            </v-card-title>
            <v-card-text>
              <CreateInvoice />
            </v-card-text>
            </v-card>
          </v-tab-item>

          <!--  UploadXml TAB Content -->
          <v-tab-item value="tab-2">
            <v-card flat>
              <v-card-text>
                <UploadXml />
              </v-card-text>
            </v-card>
          </v-tab-item>

          <!--  UploadExcel Content -->
          <v-tab-item value="tab-3">
            <v-card flat>
              <v-card-text>
                <UploadExcel />
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CreateInvoice from "../components/CreateInvoice.vue";
import UploadXml from "../components/UploadXml.vue";
import UploadExcel from "../components/UploadExcel.vue";

export default {
  name: "NewInvoice",
  components: {
    CreateInvoice,  
    UploadXml,
    UploadExcel
  },
  data() {
    return {
      tab: null,
    };
  },
  methods: {
  }
};
</script>

<style scoped>
</style>
